import { ControlConstants } from "../../control/constant/ControlConstants";
import { ButtonProperties } from "../../control/properties/ButtonProperties";
import { DialogProperties } from "../../control/properties/DialogProperties";
import { PanelProperties } from "../../control/properties/PanelProperties";
import { SpriteProperties } from "../../control/properties/SpriteProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { ResponsibleGamingDialog } from "../display/ResponsibleGamingDialog";
import { CommonLang } from "../lang/CommonLang";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
/**
 * AbstractResponsibleGamingDialogProperties.ts
 */
export class AbstractResponsibleGamingDialogProperties extends DialogProperties {
    equals(other) {
        return super.equals(other) &&
            this.panelProperties.equals(other.panelProperties) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.cancelButtonProperties.equals(other.cancelButtonProperties) &&
            this.confirmButtonProperties.equals(other.confirmButtonProperties) &&
            this.extraSpinPanelProperties.equals(other.extraSpinPanelProperties) &&
            this.spinPricePanelProperties.equals(other.spinPricePanelProperties) &&
            this.singleGameStakePanelProperties.equals(other.singleGameStakePanelProperties) &&
            this.maximumLossPanelProperties.equals(other.maximumLossPanelProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties = new SpriteProperties(CommonStyle.MESSAGE_DIALOG_1, CommonStyle.MODULE);
        this.panelProperties = new PanelProperties();
        this.confirmButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_0, CommonStyle.MODULE);
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_0, null, CommonLang.SAVE_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
        this.cancelButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_0, CommonStyle.MODULE);
        this.cancelButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_0, null, CommonLang.CANCEL_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
    }
    getClass() {
        return ResponsibleGamingDialog;
    }
    getClassName() {
        return "ResponsibleGamblingDialog";
    }
}
//# sourceMappingURL=AbstractResponsibleGamingDialogProperties.js.map